import { useQuery } from '@tanstack/react-query';
import { fetchSpec } from './api';
import { ReviewPanel } from './ReviewPanel';
import { SectionLayout } from './SectionLayout';
import { getSectionStatus, useRequestId } from './sectionHelpers';

const NameTable = ({ title, names }: { title: string; names: string[] }) => (
  <>
    <h3 style={{ fontSize: 18 }}>{title}</h3>
    <table className="table table-bordered">
      <tbody>
        {names.map((name) => (
          <tr key={name}>
            <td>{name}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </>
);

export const VerificationSpecPage = () => {
  const requestId = useRequestId();
  const { data, isLoading, error } = useQuery({
    queryKey: ['verification', 'spec', requestId],
    queryFn: () => fetchSpec(requestId),
  });
  const status = getSectionStatus(data?.status);

  return (
    <SectionLayout title="Специализация" status={status} isLoading={isLoading} error={error}>
      {data && (
        <>
          <NameTable title="Марки автомобилей" names={(data.auto_marks ?? []).map((m) => m.mark_name)} />
          <NameTable title="Типы работ" names={(data.work_types ?? []).map((w) => w.name)} />
          <ReviewPanel
            requestId={requestId}
            section="specialization"
            status={status}
            initialRejectMessage={data.reject_message}
          />
        </>
      )}
    </SectionLayout>
  );
};
